module.exports = __webpack_public_path__ + "img/residence-min.d9250449.png";